const printer = (state = null, action) => {
  switch (action.type) {
    case "SET_PRINTER":
      return action.payload;
    default:
      return state;
  }
};

export default printer;
